<!--
 * @Author: your name
 * @Date: 2021-10-18 15:58:04
 * @LastEditTime: 2021-10-20 10:31:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\manage\preemption\index.vue
-->
<template>
  <div class="app-container">
    <el-form ref="form" :model="form" :rules="activeName === '1' ? rules : {}">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="$t('SettingOrderSourceDeploy.tab1')" name="1">
          <el-form-item :label="$t('SettingOrderSourceDeploy.sourcing')" prop="value1">
            <el-radio-group v-model="form.value1" @change="onChange">
              <el-radio :label="1">{{ $t('SettingOrderSourceDeploy.stockOut') }}</el-radio>
              <el-radio :label="2">{{ $t('SettingOrderSourceDeploy.reSource') }}</el-radio>
              <el-radio :label="3">{{ $t('SettingOrderSourceDeploy.manual') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.value1 === 2">
            <el-form-item :label="$t('SettingOrderSourceDeploy.resourceInterval')" prop="interval">
              <el-select v-model="form.interval" :placeholder="$t('chooseText')">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SettingOrderSourceDeploy.resources')" prop="value2">
              <BjInputNumber v-model="form.value2" width="180px">
                <template slot="append">{{ $t('SettingOrderSourceDeploy.secondRate') }}</template>
              </BjInputNumber>
            </el-form-item>
            <el-form-item :label="$t('SettingOrderSourceDeploy.resourcesFail')" prop="value3">
              <el-radio-group v-model="form.value3">
                <el-radio :label="1">{{ $t('SettingOrderSourceDeploy.stockOut') }}</el-radio>
                <el-radio :label="2">{{ $t('SettingOrderSourceDeploy.manual') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </el-tab-pane>
        <el-tab-pane :label="$t('SettingOrderSourceDeploy.tab2')" name="2">
          <el-form-item :label="$t('SettingOrderSourceDeploy.tabTitle')" prop="value">
            <el-switch v-model="form.value" />
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
      <el-form-item>
        <el-button v-permission:SettingOrderSourceDeployConfig_Save type="primary" @click="onSubmit"
          >{{ $t('okText') }}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
const getDefaultForm = () => {
  return {
    value: true,
    value1: 1,
    value2: null,
    value3: 1,
    interval: null,
  };
};
export default {
  name: 'SettingManagePreemption',
  data() {
    return {
      form: getDefaultForm(),
      rules: {
        value1: [{ required: true, message: this.$t('SettingOrderSourceDeploy.sourcingText'), trigger: 'change' }],
        value2: [{ required: true, message: this.$t('SettingOrderSourceDeploy.resourcesText'), trigger: 'change' }],
        interval: [{ required: true, message: this.$t('SettingOrderSourceDeploy.resourceIntervalText'), trigger: 'blur' }],
        value3: [{ required: true, message: this.$t('SettingOrderSourceDeploy.resourcesFailText'), trigger: 'change' }],
      },
      activeName: '1',
      options: [
        {
          value: 5,
          label: '5秒',
        },
        {
          value: 10,
          label: '10秒',
        },
        {
          value: 20,
          label: '20秒',
        },
        {
          value: 30,
          label: '30秒',
        },
        {
          value: 60,
          label: '60秒',
        },
      ],
    };
  },
  methods: {
    handleClick(tab, event) {
    },
    onChange() {
      Object.assign(this.form, {
        value2: null,
        value3: 1,
        interval: null,
      });
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.msgSuccess(this.$t('toast.submitSuccessText'));
        this.form = getDefaultForm();
      });
    },
  },
};
</script>
